// extracted by mini-css-extract-plugin
export default {"title":"NewPresentationComponentPopup_title__50p1p","iconEdit":"NewPresentationComponentPopup_iconEdit__lX6kC","explanation":"NewPresentationComponentPopup_explanation__rhz6O"};